import { APP_STATES } from '@/components/app/common/constants';
import { APPS, PUBLISHED_APPS, RESET } from '../types';
import { Apps } from '@/api/api';

export const state = () => ({
  apps: [],
});

export const getters = {
  [APPS]({ apps }) {
    return apps;
  },
  [PUBLISHED_APPS]({ apps }) {
    return apps?.filter(app => app.published === APP_STATES.PUBLISHED);
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [APPS](stateObj, apps) {
    stateObj.apps = apps;
  },
  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [APPS]({ commit }) {
    return Apps.getList().then(apps => {
      commit(APPS, apps);
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
